import { customerFilm } from '../../data/cinematicJourneys';
import { FilmJourney } from './FilmJourney';

export const ExecutiveJourney = ({ department, industry, problem, onJoin }) => <FilmJourney film={customerFilm('executive', department, industry, problem)} customer onJoin={onJoin} />;